<template>
  <div class="k8m-cluster-usage-container">
    <div
      class="k8m-cluster-usage-details-chart-element"
      v-for="(chartConfig, index) in clusterUsageData"
      :key="'line' + index"
      :style="{ width: chartConfig?.width }"
    >
      <GraphBuilderV3
        v-if="isForcastEnabled && chartConfig.isForecast"
        :title="chartConfig.title"
        :queryName="chartConfig.queryName"
        :graphType="chartConfig.graphType"
        :type="chartConfig.type"
        :metricName="chartConfig.metricName"
        :params="getForecastChartParams(chartConfig)"
        :header="chartConfig.header"
        :serviceName="currentCluster.label"
        :axisLabels="chartConfig.axisLabels"
      />
      <GraphBuilder
        v-else
        :chartConfig="chartConfig"
        :index="index"
        :layoutIndex="0"
      />
    </div>
  </div>
</template>

<script>
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import GraphBuilderV3 from '@/components/Common/GraphBuilderV3.vue';
import { mapState, mapGetters } from 'vuex';

export default {
  components: { GraphBuilder, GraphBuilderV3 },
  name: 'ClusterUsageGraphs',
  props: {
    clusterUsageData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getForecastChartParams(data) {
      return {
        duration: this.isForcastEnabled
          ? this.getForecastDurationTime
          : this.getDurationTime,
        condition: {
          name: data.metricName,
          entity: {
            scope: data.entityType,
            serviceName: this.currentCluster?.key || '',
            normal: true,
            teamID: this.getTeamId,
          },
        },
      };
    },
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate', 'isForcastEnabled']),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'getForecastDurationTime',
    ]),
    ...mapState('k8State/k8CommonState', ['currentCluster']),
    ...mapGetters('globalState/user', ['getTeamId']),
  },
};
</script>

<style lang="scss" scoped>
.k8m-cluster-usage-container {
  flex-flow: row wrap;
  display: flex;
  position: relative;
  margin-top: 1.438rem;
  justify-content: space-between;
  margin-right: 1rem;
}
.k8m-cluster-usage-details-chart-element {
  width: 100%;
  margin-bottom: 1.5rem;
  margin-top: 2rem;
  margin-left: 0.125rem;
}
</style>
